import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { roleNavItems } from '../../config/roles';
import * as Icons from 'lucide-react'; 
import { LogOut, ShieldCheck } from 'lucide-react';

const Sidebar = () => {
  const { user, logout } = useAuth();
  if (!user) return null;

  const navItems = roleNavItems[user.role] || [];

  return (
    <aside className="sidebar custom-scrollbar">
      {/* BRANDING AREA */}
      <div className="sidebar-brand">
        <div className="brand-icon">
          <ShieldCheck size={20} fill="currentColor" fillOpacity={0.2} />
        </div>
        <div className="brand-text">
          <span className="brand-title">WELFARE</span>
          <span className="brand-subtitle">Admin Portal</span>
        </div>
      </div>

      {/* NAVIGATION LIST */}
      <nav className="sidebar-nav">
        <ul>
          {navItems.map((item) => {
            const IconComponent = Icons[item.icon]; 
            return (
              <li key={item.path}>
                <NavLink 
                  to={item.path} 
                  end 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <div className="nav-link-content">
                    {IconComponent ? (
                      <IconComponent size={18} strokeWidth={2.5} />
                    ) : (
                      <div className="fallback-dot" />
                    )}
                    <span>{item.name}</span>
                  </div>
                  {/* Visual active indicator bar */}
                  <div className="active-indicator" />
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* USER FOOTER */}
      <div className="sidebar-footer">
        <div className="user-profile">
          <div className="user-avatar">
            {user.full_name?.charAt(0)}
          </div>
          <div className="user-meta">
            <p className="user-name">{user.full_name}</p>
            <p className="user-role">{user.role?.replace('_', ' ')}</p>
          </div>
        </div>
        <button onClick={logout} className="logout-btn" title="Logout">
          <LogOut size={16} />
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;